if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      // onSubmitHandler(evt) {
      //   evt.preventDefault();
      //   if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      //   this.handleErrorMessage();

      //   this.submitButton.setAttribute('aria-disabled', true);
      //   this.submitButton.classList.add('loading');
      //   this.querySelector('.loading__spinner').classList.remove('hidden');

      //   const config = fetchConfig('javascript');
      //   config.headers['X-Requested-With'] = 'XMLHttpRequest';
      //   delete config.headers['Content-Type'];

      //   const formData = new FormData(this.form);
      //   if (this.cart) {
      //     formData.append(
      //       'sections',
      //       this.cart.getSectionsToRender().map((section) => section.id)
      //     );
      //     formData.append('sections_url', window.location.pathname);
      //     this.cart.setActiveElement(document.activeElement);
      //   }
      //   config.body = formData;

      //   fetch(`${routes.cart_add_url}`, config)
      //     .then((response) => response.json())
      //     .then((response) => {
      //       if (response.status) {
      //         publish(PUB_SUB_EVENTS.cartError, {
      //           source: 'product-form',
      //           productVariantId: formData.get('id'),
      //           errors: response.errors || response.description,
      //           message: response.message,
      //         });
      //         this.handleErrorMessage(response.description);
             

      //         const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
      //         if (!soldOutMessage) return;
      //         this.submitButton.setAttribute('aria-disabled', true);
      //         this.submitButtonText.classList.add('hidden');
      //         soldOutMessage.classList.remove('hidden');
      //         this.error = true;
      //         return;
      //       } else if (!this.cart) {
      //         window.location = window.routes.cart_url;
      //         return;
      //       }

      //       if (!this.error)
      //         publish(PUB_SUB_EVENTS.cartUpdate, {
      //           source: 'product-form',
      //           productVariantId: formData.get('id'),
      //           cartData: response,
      //         });
      //       this.error = false;
      //       const quickAddModal = this.closest('quick-add-modal');
      //       if (quickAddModal) {
      //         document.body.addEventListener(
      //           'modalClosed',
      //           () => {
      //             setTimeout(() => {
      //               this.cart.renderContents(response);
                    
      //             });
      //           },
      //           { once: true }
      //         );
      //         quickAddModal.hide(true);
      //       } else {
      //         this.cart.renderContents(response);
      //       }
      //     })
      //     .catch((e) => {
      //       console.error(e);
      //     })
      //     .finally(() => {
      //       this.submitButton.classList.remove('loading');
      //       if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      //       if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      //       this.querySelector('.loading__spinner').classList.add('hidden');
             
      //     });
      // }

onSubmitHandler(evt) {
  evt.preventDefault();
  if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

  this.handleErrorMessage();

  this.submitButton.setAttribute('aria-disabled', true);
  this.submitButton.classList.add('loading');
  this.querySelector('.loading__spinner').classList.remove('hidden');

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData(this.form);
  if (this.cart) {
    formData.append(
      'sections',
      this.cart.getSectionsToRender().map((section) => section.id)
    );
    formData.append('sections_url', window.location.pathname);
    this.cart.setActiveElement(document.activeElement);
  }
  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {

      if (response.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          errors: response.errors || response.description,
          message: response.message,
        });
        this.handleErrorMessage(response.description);

        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
        if (!soldOutMessage) return;
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButtonText.classList.add('hidden');
        soldOutMessage.classList.remove('hidden');
        this.error = true;
        return;
      } else if (!this.cart) {
        window.location = window.routes.cart_url;
        return;
      }

      // ✅ BUNDLE SPLIT LOGIC (Merged quantities from split + non-split items)
      return fetch(`${window.routes.cart_url}.js`)
        .then(res => res.json())
        .then(async cart => {
          const variantId = Number(formData.get('id'));

          // 1️⃣ Find all same variant items (split & non-split)
          const sameVariantItems = cart.items.filter(item => item.id === variantId);
          
          const isBundle = sameVariantItems.some(item => item.properties && item.properties.__bundleproduct === "Bundle");
          if (!isBundle) {
            return; // ✅ Normal product → exit here
          }

          // 2️⃣ Calculate total qty from all these items
          const totalQty = sameVariantItems.reduce((sum, item) => sum + item.quantity, 0);

          // 3️⃣ Only run logic if total is > 3
          if (totalQty > 3) {
            const largestMultipleOf3 = Math.floor(totalQty / 3) * 3;
            const extraQty = totalQty - largestMultipleOf3;

            // 4️⃣ First: update the main bundle item (non-split one)
            const mainItem = sameVariantItems.find(item => !item.properties._split_item);
            if (mainItem) {
              await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  id: mainItem.key,
                  quantity: largestMultipleOf3
                })
              });
            }

            // 5️⃣ Remove all old split items
            const splitItems = sameVariantItems.filter(item => item.properties._split_item);
            for (const splitItem of splitItems) {
              await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: splitItem.key, quantity: 0 })
              });
            }

            // 6️⃣ If remainder exists, add new split item
            if (extraQty > 0) {
              const newFormData = new FormData();
              newFormData.append('id', variantId);
              newFormData.append('quantity', extraQty);
              newFormData.append('properties[__bundleproduct]', 'Bundle');
              newFormData.append('properties[_split_item]', variantId);

              await fetch(`${routes.cart_add_url}`, {
                method: 'POST',
                headers: {
                  'X-Requested-With': 'XMLHttpRequest'
                },
                body: newFormData
              });
            }
          }
        })
        .then(() => {
          // ✅ After split, publish cart update
          if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });
          }
          this.error = false;

          // const runPromptCheck = () => {
          //   setTimeout(() => {
          //     fetch('/cart.json')
          //       .then(res => res.json())
          //       .then(data => {
          //         const bundleQuantity = data.items.reduce((total, item) => {
          //           if (item.properties && item.properties.__bundleproduct === "Bundle") {
          //             return total + item.quantity;
          //           }
          //           return total;
          //         }, 0);

          //         console.log('Total Bundle Product Quantity:', bundleQuantity);

          //         const prompt = document.querySelector('.show_prompt');
          //         if (!prompt) return;

          //         const oneQty = prompt.querySelector('.show_one_qty');
          //         const twoQty = prompt.querySelector('.show_two_qty');

          //         if (bundleQuantity === 1) {
          //           oneQty.style.display = 'block';
          //           twoQty.style.display = 'none';
          //           prompt.style.display = 'block';
          //         } else if (bundleQuantity === 2) {
          //           oneQty.style.display = 'none';
          //           twoQty.style.display = 'block';
          //           prompt.style.display = 'block';
          //         } else if (bundleQuantity >= 3) {
          //           prompt.style.display = 'none';
          //         }
          //       });
          //   }, 800); 
          // };

const runPromptCheck = () => {
  setTimeout(() => {
    fetch('/cart.json')
      .then(res => res.json())
      .then(data => {
        // ✅ Filter only bundle items
        const bundleItems = data.items.filter(
          item => item.properties && item.properties.__bundleproduct === "Bundle"
        );

        bundleItems.forEach(item => {
          const variantId = item.id;
          const variantQty = item.quantity;
          console.log('Bundle Variant:', variantId, 'Qty:', variantQty);

          const prompt = document.querySelector(`.show_prompt[data-variant-id="${variantId}"]`);
          if (!prompt) return;
          const oneQty = prompt.querySelector('.show_one_qty');
          const twoQty = prompt.querySelector('.show_two_qty');

          if (variantQty === 1) {
            oneQty.style.display = 'block';
            twoQty.style.display = 'none';
            prompt.style.display = 'block';
          } else if (variantQty === 2) {
            oneQty.style.display = 'none';
            twoQty.style.display = 'block';
            prompt.style.display = 'block';
          } else if (variantQty >= 3) {
            prompt.style.display = 'none';
          }
        });
      });
  }, 800);
};



          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(response);
                  runPromptCheck();
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
            runPromptCheck();
          }
        });
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      this.submitButton.classList.remove('loading');
      if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      this.querySelector('.loading__spinner').classList.add('hidden');
    });
}



      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
